import TimelineCardSmall from "./TimelineCardSmall";
export default TimelineCardSmall;